import { useContext } from 'react';

import * as Select from '@radix-ui/react-select';
import clsx from 'clsx';

import { ChevronDown, Moon, PaintPot, Sun, SystemSettings } from '../Icons';

import { ThemeContext } from './ThemeProvider';

import styles from './ThemeSwitcher.module.scss';

type ThemeSwitcherProps = {
  isExpanded?: boolean;
  t: (key: string, options: { _key: string; _tags?: string[] }) => string;
};

export const ThemeSwitcher = ({ t, isExpanded = false }: ThemeSwitcherProps) => {
  const { theme, handleThemeChange } = useContext(ThemeContext);

  const themeOptions = [
    { value: 'light', label: t('Always light', { _key: 'theme.always_light' }), icon: Sun },
    { value: 'dark', label: t('Always dark', { _key: 'theme.always_dark' }), icon: Moon },
    { value: 'system', label: t('System settings', { _key: 'theme.system_settings' }), icon: SystemSettings },
  ];

  return (
    <Select.Root value={theme} onValueChange={handleThemeChange}>
      <Select.Trigger
        className={clsx(styles['select-trigger'], {
          [styles.collapsed]: !isExpanded,
        })}
      >
        <Select.Value asChild>
          <div className={clsx(styles.option, styles['trigger-option'], { [styles.collapsed]: !isExpanded })}>
            <PaintPot />
            <span>{t('Appearance', { _key: 'theme.appearance' })}</span>
            <ChevronDown className={styles.chevron} />
          </div>
        </Select.Value>
      </Select.Trigger>
      <Select.Content position="popper">
        <Select.Viewport className={clsx(styles['select-viewport'], { [styles.collapsed]: !isExpanded })}>
          {themeOptions.map((option, index) => {
            return (
              <Select.Item
                value={option.value}
                key={index}
                className={clsx(styles['select-item'], {
                  [styles.collapsed]: !isExpanded,
                })}
              >
                <Select.ItemText asChild>
                  <div className={clsx(styles.option, { [styles.collapsed]: !isExpanded })}>
                    <option.icon />
                    <span>{option.label}</span>
                  </div>
                </Select.ItemText>
              </Select.Item>
            );
          })}
        </Select.Viewport>
      </Select.Content>
    </Select.Root>
  );
};
